const accBtn = document.querySelectorAll('.acc__txt')

accBtn.forEach((accBtnList) => {
    const ans = accBtnList.nextElementSibling
    let height = (ans.clientHeight + 1) / window.innerWidth * 100;
    ans.style.height = "0vw"
    if (accBtnList.parentNode.classList.contains("now")) {
        ans.style.height = `${height}vw`
        accBtnList.parentNode.classList.add("is-on")
    }
    if (accBtnList.classList.contains("plus")) {
        accBtnList.querySelector("span").addEventListener('click', () => {
            openAcc()
        });
    } else {
        accBtnList.addEventListener('click', () => {
            openAcc()
        });
    }

    function openAcc() {
        const accBtnParent = accBtnList.parentNode
        accBtnParent.classList.toggle("is-on")

        if (accBtnParent.classList.contains("is-on")) {
            ans.style.height = `${height}vw`
        } else {
            ans.style.height = "0vw"
        }
    }
});